import { render, staticRenderFns } from "./AddDictionary.vue?vue&type=template&id=43f80ab6&"
import script from "./AddDictionary.vue?vue&type=script&lang=js&"
export * from "./AddDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports